import * as React from 'react';
import { Modal } from '@fedsim/components';
interface ToggleProps {
  onClick: () => void;
}
interface BasicModalProps {
  children?: React.ReactNode;
  Content: React.FC;
  Toggle: React.FC<ToggleProps>;
}

export function BasicModal({ Content, Toggle, children }: BasicModalProps): JSX.Element {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Toggle onClick={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <>
          <Content />
          {children}
        </>
      </Modal>
    </div>
  );
}

export default BasicModal
